import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const books = [{
    src: 'https://cdn.magicpatterns.com/uploads/uzVcmMiLu1ipfH9uEDEbht/bono_4.png',
    alt: 'Tabla de Conversiones y Trucos de Repostería',
    rotate: -8,
    z: 10,
    delay: 0.5
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/g9AaoEg2otWtRz43zT2yt6/bono_1.png',
    alt: 'Recetario Especial de Budines Salados',
    rotate: -4,
    z: 20,
    delay: 0.35
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nawWvpqHPEcVQZh4mEzqsy/0_Cover_1.png',
    alt: 'Coberturas y Glaseados Perfectos - Producto Principal',
    rotate: 0,
    z: 30,
    delay: 0.2,
    isMain: true
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/8ypHRLb9VEDK6jfR25tRfv/bono_2.png',
    alt: 'Guía de Coberturas y Glaseados para Budines',
    rotate: 4,
    z: 20,
    delay: 0.4
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/96MkCzRENFR6zfrQegjT5j/bono_3.png',
    alt: 'Kit para Empezar a Vender Budines Caseros',
    rotate: 8,
    z: 10,
    delay: 0.55
  }];
  return <section className="pt-28 pb-16 px-4 bg-gradient-to-b from-[#FFF8F0] to-[#FFF5EB] text-[#3D2B1F] min-h-[90vh] flex flex-col items-center justify-center" data-id="element-65">
      <div className="max-w-5xl mx-auto text-center" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-67">
          <h1 className="text-4xl md:text-6xl font-black mb-4 leading-tight" data-id="element-68">
            Coberturas y Glaseados{' '}
            <span className="text-[#C67B30]" data-id="element-69">Perfectos</span>
          </h1>
          <p className="text-xl md:text-2xl text-[#6B5344] mb-12 font-medium max-w-2xl mx-auto" data-id="element-70">
            30 Recetas para Transformar Cualquier Budín en una Delicia
          </p>
        </motion.div>

        {/* Pack display - all books in a row */}
        <div className="relative cursor-pointer group max-w-4xl mx-auto mb-12" onClick={scrollToOffer} data-id="element-71">
          {/* Subtle glow behind */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[60%] bg-[#C67B30]/8 rounded-full blur-[80px] group-hover:bg-[#C67B30]/12 transition-colors duration-500 pointer-events-none" data-id="element-72"></div>

          {/* Books row */}
          <div className="flex items-end justify-center -space-x-6 md:-space-x-10 relative" data-id="element-73">
            {books.map((book, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: book.delay
          }} className="relative flex-shrink-0" style={{
            zIndex: book.z
          }} data-id="element-74">
                <div className={`relative transition-all duration-500 ${book.isMain ? 'group-hover:scale-105 group-hover:-translate-y-3' : 'group-hover:scale-[1.02]'}`} style={{
              transform: `rotate(${book.rotate}deg)`
            }} data-id="element-75">
                  <img src={book.src} alt={book.alt} className={`object-contain rounded-lg ${book.isMain ? 'w-[140px] md:w-[220px] lg:w-[260px] drop-shadow-[0_15px_40px_rgba(61,43,31,0.3)]' : 'w-[100px] md:w-[160px] lg:w-[200px] drop-shadow-[0_10px_30px_rgba(61,43,31,0.2)]'}`} data-id="element-76" />
                  {book.isMain ? <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C67B30] text-white text-[10px] md:text-xs font-black px-3 py-1 rounded-full shadow-md uppercase tracking-wider whitespace-nowrap" data-id="element-77">
                      ⭐ Libro Principal
                    </div> : <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-red-500 text-white text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm uppercase tracking-wider whitespace-nowrap" data-id="element-78">
                      🎁 Gratis
                    </div>}
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} data-id="element-79">
          <button onClick={scrollToOffer} className="w-full sm:w-auto bg-gradient-to-r from-[#C67B30] to-[#D4943A] text-white font-black text-xl md:text-2xl py-5 px-10 rounded-xl shadow-[0_0_20px_rgba(198,123,48,0.3)] hover:shadow-[0_0_30px_rgba(198,123,48,0.5)] transform hover:scale-105 transition-all duration-300 uppercase tracking-wide" data-id="element-80">
            ¡Quiero mi recetario ahora!
          </button>
        </motion.div>
      </div>
    </section>;
}